/**
 * 경로 분기.
 *
 * - `/`      … 인트로를 띄우고 체험 계정으로 곧장 월드에 들어간다
 * - `/login` … 로그인 폼을 보여준다 (자기 계정으로 들어오는 사람용)
 *
 * Cloudflare Pages와 Vite dev 서버 모두 없는 경로를 index.html로 되돌려주므로
 * (`public/_redirects`) 라우터 없이 pathname만 보고 갈라도 된다.
 */

/** 로그인 폼을 보여줄 경로. 끝의 슬래시 유무는 가리지 않는다. */
const LOGIN_PATHS = ['/login', '/login/'];

export function isLoginRoute(pathname: string = window.location.pathname): boolean {
  return LOGIN_PATHS.includes(pathname.toLowerCase());
}

/** 인트로를 띄우고 자동으로 월드까지 들어가는 경로인지. */
export function isIntroRoute(pathname: string = window.location.pathname): boolean {
  return !isLoginRoute(pathname);
}
